import React from 'react';
import {post} from '../../utils/request';
import Alert from "../../component/Alert/Alert";
import Button from "../../component/Button/Button";
import Layout from "../../component/Layout/Layout";
import Link from "../../component/Link/Link";
import { Col, Form, Row } from 'react-bootstrap';
import './password.scss';

class PasswordForgot extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            errorMessage: "",
            errors: {},
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.hasError = this.hasError.bind(this);
        this.showError = this.showError.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    async handleSubmit(event) {
        event.preventDefault();

        this.setState({errorMessage: ""});

        const data = {
            email: this.state.email,
            name: this.state.name,
            pass: this.state.pass,
        };

        const [res, err] = await post(this, "/passwordReset/start", data);
        if (err) {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 404:
                        this.setState({errorMessage: "This email does not allow a password reset. Please make sure you have entered the correct email."});
                        this.setState({errors: {}});
                        return;
                    case 422:
                        const errors = err.response.data.ValidationErrors;

                        this.setState({errors: errors});
                        return;
                }
            }
            this.setState({errorMessage: "error: " + err});
            return;
        }
        this.props.history.push('/password/sent');
    }

    hasError(field) {
        if (this.state.errors[field]) {
            return true;
        }
        return false;
    }

    showError(field) {
        const error = this.state.errors[field];
        if (error) {
            this.errorTranslator(error, field)
            return error.message;
        }
        return;
    }

    errorTranslator(error, field) {
        if (error.key === "length") {
            error.message = "Please enter a valid " + field.toLowerCase();
        }
        if (error.key === "email") {
            error.message = "Please enter a valid " + field.toLowerCase();
        }
    }

    render() {
        return <Layout activeMenu="/signIn">
            <div className="password-ctr">
                <h1>Forgot your password?</h1>
                <p>Don't worry, we will send you a password reset link to your email.</p>
                <Form onSubmit={e => this.handleSubmit(e)}>
                    {this.state.errorMessage && <Alert variant="danger">{this.state.errorMessage}</Alert>}
                    <Form.Group as={Row} controlId="formPlaintextUser">
                        <Form.Label column sm="2">Email</Form.Label>
                        <Col sm="10">
                            <Form.Control
                                type="email"
                                name="email"
                                isInvalid={this.hasError("email")}
                                onChange={this.handleChange}
                            />
                            <Form.Control.Feedback type="invalid">{this.showError("email")}</Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                    <div className="password-forget-ctr">
                        <Col>
                            <Row>
                                <Button type="submit" className="btn primary btn-xl" label="Request password reset"/>
                            </Row>
                            <Row>
                                <Link className="lnk" href="/signIn" label="Or go back to sign in"/>
                            </Row>
                        </Col>
                    </div>
                </Form>
            </div>
        </Layout>;
    }
}

export default PasswordForgot